import validate from "/working_dir/site/node_modules/nuxt/dist/pages/runtime/validate.js";
import _00_45init_45data_45global from "/working_dir/site/middleware/00.init-data.global.ts";
import _10_45inactive_45site_45redirect_45global from "/working_dir/site/middleware/10.inactive-site-redirect.global.ts";
import manifest_45route_45rule from "/working_dir/site/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _00_45init_45data_45global,
  _10_45inactive_45site_45redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}